module.exports = __webpack_public_path__ + "img/img_app_store.de222125.png";